export class HubConstants {
  public static HUBS = 'widgets'
}
